import React from "react";

type ArrowProps = {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
  };
  

function PrevArrow({ className, style, onClick }: ArrowProps) {
  return (
    <div
      className={className}
      onClick={onClick}
      style={{ ...style, fontSize: 0,
      lineHeight: 0,
      position: "absolute",
      top: "50%",
      display: "block",
      width: "30px",
      height: "30px",
      padding: 0,
      transform: "translate(0, -50%)",
      cursor: "pointer",
      color: "transparent",
      border: "none",
      outline: "none",
      background: "transparent",
      zIndex: 1,
      left: "-18px"}}
    >
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="15" cy="15" r="14.5" fill="#18468F" stroke="#18468F"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M17.7634 20.7803C17.4376 21.0732 16.9093 21.0732 16.5835 20.7803L10.7432 15.5303C10.4174 15.2374 10.4174 14.7626 10.7432 14.4697L16.5835 9.21967C16.9093 8.92678 17.4376 8.92678 17.7634 9.21967C18.0893 9.51256 18.0893 9.98744 17.7634 10.2803L12.5131 15L17.7634 19.7197C18.0893 20.0126 18.0893 20.4874 17.7634 20.7803Z" fill="white"/>
        </svg>
    </div>
 );
}

export default PrevArrow;